
import { useState } from 'react';

export const useReviewRequest = () => {
  const [requestReview, setRequestReview] = useState(false);
  const [selectedReviewers, setSelectedReviewers] = useState<string[]>([]);

  // Mock users for reviewer selection
  const allUsers = [
    { id: '1', name: 'John Doe' },
    { id: '2', name: 'Jane Smith' },
    { id: '3', name: 'Bob Johnson' },
  ];

  return {
    requestReview,
    setRequestReview,
    selectedReviewers,
    setSelectedReviewers,
    allUsers
  };
};
